import { Component, h } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import Icon from '../assets'
import BigCard from './assets/BigCard'
import SmallCard from './assets/SmallCard'
import Radio, { RadioGroup } from '../design-system-components/radio'

interface Props {
  controlUrl: string
  title: string
  selectedTemplate: number
  displayOnlyParent: boolean
  onChange: (state: {title: string, selectedTemplate: number, displayOnlyParent: boolean}) => void
}

interface State {
  title: string
  contentIsExtended: boolean
  templateIsExtended: boolean
  selectedTemplateOption: number
  displayOnlyParent: boolean
}

class CommunityCategoryWithHelp extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      title: props.title,
      contentIsExtended: false,
      templateIsExtended: true,
      selectedTemplateOption: props.selectedTemplate,
      displayOnlyParent: props.displayOnlyParent
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeTemplate = this.onChangeTemplate.bind(this)
    this.notifyChanges = this.notifyChanges.bind(this)
    this.onChangeDisplayChildrenProperty = this.onChangeDisplayChildrenProperty.bind(this)
  }

  templateOptions = [{
    visual: <BigCard />,
    text: 'Big category card'
  }, {
    visual: <SmallCard />,
    text: 'Small category card'
  }]

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, this.notifyChanges)
  }

  onChangeTemplate (idx: number) {
    this.setState({ selectedTemplateOption: idx }, this.notifyChanges)
  }

  onChangeDisplayChildrenProperty (displayOnlyParent: boolean) {
    this.setState({ displayOnlyParent: displayOnlyParent }, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange({
      title: this.state.title,
      selectedTemplate: this.state.selectedTemplateOption,
      displayOnlyParent: this.state.displayOnlyParent
    })
  }

  render ({ controlUrl }: Props, { title, contentIsExtended, templateIsExtended, selectedTemplateOption, displayOnlyParent }: State) {
    return (
      <div className='widget-configurator_tabs-wrapper'>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-template'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ templateIsExtended: !templateIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={templateIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            TEMPLATE
          </div>

          {
            templateIsExtended
              ? (
                <div className='widget-configurator_tab-content'>
                  <div className='card-content-selector'>
                    <RadioGroup>
                      <Radio
                        id='only-parent' label='label' name='card-selector'
                        value={<div>
                          <b>Display only parent categories</b>
                          <p>Choose this if you have many parent categories.</p>
                        </div>}
                        isChecked={displayOnlyParent}
                        onChange={() => this.onChangeDisplayChildrenProperty(true)}
                      />
                      <Radio
                        id='parent-child' label='label 2' name='card-selector'
                        value={<div>
                          <b>Display child and parent categories</b>
                          <p>Choose this if you have fewer parent categories.</p>
                        </div>}
                        isChecked={!displayOnlyParent}
                        onChange={() => this.onChangeDisplayChildrenProperty(false)}
                      />
                    </RadioGroup>
                  </div>
                  <div className='card-styling-selector'>
                    {
                    this.templateOptions.map((option, id) => (
                      <div
                        key={id}
                        className={`widget-configurator_template-option ${(id === selectedTemplateOption) ? 'checked' : ''}`}
                        onClick={() => this.onChangeTemplate(id)}
                      >
                        {option.visual}
                        <div>{option.text}</div>
                        <Icon size={16} icon='checkbox' customClass='checkbox-icon' />
                      </div>
                    ))
                  }
                  </div>

                </div>
                )
              : null
          }
        </div>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-content'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ contentIsExtended: !contentIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={contentIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            CONTENT
          </div>
          {
            contentIsExtended
              ? (
                <div className='widget-configurator_tab-content'>
                  <InputGroup
                    title='Title'
                    type='text'
                    onChange={(e: ChangeEvent) => { this.onChangeTitle(e.target.value) }}
                    value={title}
                  />
                  <div className='widget-configuration_info-box'>
                    <strong>✨ How to edit community category card</strong>
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <p>Please go to <a target='_blank' href={`${controlUrl}/settings/category/overview`}>community category overview in control</a> to reorder the categories. And in each parent category page, you can change title, description and visual (thumbnail image) for every card.</p>
                  </div>
                </div>
                )
              : null
          }
        </div>
      </div>
    )
  }
}

export default CommunityCategoryWithHelp
